import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ShowLiveBadge extends BaseOption {
  static userInterfaceComponent = {
    label: "Show Live Badge",
    optionDataType: BaseOption.DataType.Boolean,
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "The LIVE badge shown while a livestream is on air, to the host and to viewers.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = true;

  static convertConfigValueToCompiledValue(configValue) {
    return [true, "true", "yes"].includes(configValue);
  }
}
